import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalConstants } from 'src/app/common/global-constants';
import { WebServiceService } from 'src/app/services/web-service.service';
import IButton from '../../atoms/button/types/IButton';

@Component({
  selector: 'app-passolig-mobil-modal',
  templateUrl: './passolig-mobil-modal.component.html',
  styleUrls: ['./passolig-mobil-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PassoMobilModalComponent implements OnInit {
  @Output() output = new EventEmitter<any>();
  btnGonder: IButton;
  hasError: boolean = false;
  successStatus: boolean = false;
  failStatus: boolean = false;
  phonenumber: string;
  isActive = false;
  modalStatusSubs: Subscription;
  public lang: string = GlobalConstants.lang;
  constructor(
    private webservice: WebServiceService
  ) {
    this.btnGonder = {
      item_title: "İndirme Linkini Gönder",
      item_css: "button-contained",
      item_url: "#"
    }
  }

  ngOnInit(): void {
    this.modalStatusSubs = this.webservice
      .getPassoModalSmsStatus()
      .subscribe((res) => {
        this.isActive = res.status;
        if(res.status) {
          this.successStatus = false;
          this.failStatus = false;
          if(typeof window !== 'undefined') {
            document.getElementsByTagName('body')[0].classList.add('open-modal');
          }
        }
      });
  }

  sendPhoneNumber($event: any) {
    $event.preventDefault();
    this.hasError = false;
    const phoneno = /^(5)([0-9]+)$/;
    if (this.phonenumber) {
      if (this.phonenumber.length == 10 && this.phonenumber.match(phoneno)) {
        const data = {
          number: '+90' + this.phonenumber,
          type: 'PASSO'
        };
        this.sendSms(data); // This sends the user data to the backend
        return;
      }
    }
    
    this.hasError = true;
  }

  sendSms(data: any) {
    if(this.successStatus) return;
    this.webservice
      .HttpPostAuthNonProxy('/form/send-sms', data, false, this.lang == 'en' ? true : false)
      .subscribe((res: any) => {
        if (res.status) {
          this.successStatus = true;
          this.webservice.dataLayerEvent('Form Event','Passolig Form Submit','Success',false,'gaEvent');
        } else {
          this.failStatus = true;
          this.webservice.dataLayerEvent('Form Event','Passolig Form Error',res.message,false,'gaEvent');
        }
      });
  }

  getBtnByLang()
  {
    if(this.lang == 'tr') {
      this.btnGonder = {
        item_title: "İndirme Linkini Gönder",
        item_css: "button-contained",
        item_url: "#"
      }
    } else {
      this.btnGonder = {
        item_title: "Send Download Link",
        item_css: "button-contained",
        item_url: "#"
      }
    }
    return this.btnGonder;
  }

  close($event: any) {
    if(typeof window !== 'undefined') {
      document.getElementsByTagName('body')[0].classList.remove('open-modal');
    }
    this.isActive = false;
    $event.preventDefault();
    this.output.emit('closed');
  }


}
